var render = function render(){
  var _vm$maintenanceDetail5, _vm$maintenanceDetail6, _vm$maintenanceDetail7, _vm$maintenanceDetail8, _vm$maintenanceDetail9, _vm$maintenanceDetail0, _vm$maintenanceDetail1;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "border-bottom": "1px solid #dee2e6"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Maintenance Date")]), _c('td', {
    attrs: {
      "else": ""
    }
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.maintenanceDetailData.maintenanceDate)))])]), _vm.maintenanceDetailData.trigger === 'COUNTER' ? _c('tr', [_c('td', [_vm._v("Maintenance Running Hours")]), _c('td', [_vm.maintenanceDetailData.trigger === 'COUNTER' ? _c('p', [_vm._v(_vm._s(_vm.maintenanceDetailData.lastMaintenanceHours) + " HOURS")]) : _vm._e()])]) : _vm._e(), _c('tr', [_c('td', [_vm._v("Attachment")]), _c('td', [_c('b-badge', {
    staticClass: "cursor-pointer",
    attrs: {
      "variant": "warning"
    },
    on: {
      "click": function click($event) {
        var _vm$maintenanceDetail, _vm$maintenanceDetail2, _vm$maintenanceDetail3, _vm$maintenanceDetail4;
        return _vm.handleOpenFilePreview((_vm$maintenanceDetail = _vm.maintenanceDetailData) === null || _vm$maintenanceDetail === void 0 ? void 0 : (_vm$maintenanceDetail2 = _vm$maintenanceDetail.file) === null || _vm$maintenanceDetail2 === void 0 ? void 0 : _vm$maintenanceDetail2.url, (_vm$maintenanceDetail3 = _vm.maintenanceDetailData) === null || _vm$maintenanceDetail3 === void 0 ? void 0 : (_vm$maintenanceDetail4 = _vm$maintenanceDetail3.file) === null || _vm$maintenanceDetail4 === void 0 ? void 0 : _vm$maintenanceDetail4.fileName);
      }
    }
  }, [_vm._v(_vm._s((_vm$maintenanceDetail5 = _vm.maintenanceDetailData) === null || _vm$maintenanceDetail5 === void 0 ? void 0 : (_vm$maintenanceDetail6 = _vm$maintenanceDetail5.file) === null || _vm$maintenanceDetail6 === void 0 ? void 0 : _vm$maintenanceDetail6.fileName))])], 1)]), _c('tr', [_c('td', [_vm._v("Cost")]), _c('td', [_vm._v("Rp." + _vm._s(_vm.numberFormat(_vm.maintenanceDetailData.cost)))])]), (_vm$maintenanceDetail7 = _vm.maintenanceDetailData) !== null && _vm$maintenanceDetail7 !== void 0 && _vm$maintenanceDetail7.poponedDate ? _c('tr', [_c('td', [_vm._v("Posponed Date")]), _c('td', {
    attrs: {
      "else": ""
    }
  }, [_vm._v(_vm._s(_vm.formatDate((_vm$maintenanceDetail8 = _vm.maintenanceDetailData) === null || _vm$maintenanceDetail8 === void 0 ? void 0 : _vm$maintenanceDetail8.poponedDate)))])]) : _vm._e(), (_vm$maintenanceDetail9 = _vm.maintenanceDetailData) !== null && _vm$maintenanceDetail9 !== void 0 && _vm$maintenanceDetail9.posponedRh ? _c('tr', [_c('td', [_vm._v("Pospones (RH)")]), _c('td', {
    attrs: {
      "else": ""
    }
  }, [_vm._v(_vm._s((_vm$maintenanceDetail0 = (_vm$maintenanceDetail1 = _vm.maintenanceDetailData) === null || _vm$maintenanceDetail1 === void 0 ? void 0 : _vm$maintenanceDetail1.posponedRh) !== null && _vm$maintenanceDetail0 !== void 0 ? _vm$maintenanceDetail0 : '-'))])]) : _vm._e(), _c('tr', [_c('td', {
    staticClass: "align-top"
  }, [_vm._v("Current Notes")]), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm.maintenanceDetailData.status === 'APPROVE' ? _c('span', [_vm._v(_vm._s(_vm.maintenanceDetailData.finishNotes))]) : _c('span', [_vm._v(_vm._s(_vm.maintenanceDetailData.notes))])])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }